export default __webpack_public_path__ + "291ed363cfe5d0ec014abcf2c4b08ee4.svg";